import { gql } from '@apollo/client'

export const BULK_UPDATE_EXTERNAL_WORK_ITEMS = gql`
  mutation BulkUpdateExternalWorkItems(
    $input: BulkUpdateExternalWorkItemInput!
  ) {
    bulkUpdateExternalWorkItems(input: $input) {
      id
      status
      assigneeId
      notes
      assignee {
        id
        firstName
        lastName
        email
      }
    }
  }
`
